var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3040_2040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00134 15.2114L9.96553 17.1756M8.00134 15.2114L3.28729 10.4974C2.63642 9.84653 2.64697 8.7807 3.31086 8.11681C3.97476 7.45292 5.04058 7.44236 5.69146 8.09324M8.00134 15.2114C7.35047 14.5606 6.28464 14.5711 5.62075 15.235C4.95686 15.8989 4.9463 16.9647 5.59718 17.6156L7.16852 19.187C10.4229 22.4413 15.752 22.3886 19.0715 19.0691C22.3909 15.7496 22.4437 10.4205 19.1893 7.16614L15.261 3.23777C14.6101 2.5869 13.5443 2.59745 12.8804 3.26134C12.2165 3.92523 12.2059 4.99106 12.8568 5.64193M5.69146 8.09324L10.0127 12.4144M5.69146 8.09324L4.90578 7.30756C4.25491 6.65669 4.26546 5.59086 4.92935 4.92697C5.59324 4.26308 6.65907 4.25253 7.30995 4.9034L8.09562 5.68907M8.09562 5.68907L12.4168 10.0103M8.09562 5.68907C7.44475 5.0382 7.4553 3.97237 8.11919 3.30848C8.78308 2.64459 9.84891 2.63404 10.4998 3.28491L12.8568 5.64193M12.8568 5.64193L14.821 7.60612",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3040_2040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.7157b033068e9a35d0f3426eca24bb76.svg";
export { ForwardRef as ReactComponent };